import store from '../store';
import {i18n} from '../plugins/i18n'
export default function (to, from ,next) {
    return new Promise((resolve , reject) => {
        if(store.getters.user.website_role && store.getters.user.website_role.name && store.getters.user.website_role.name == 'admin'){
            resolve(true);
        }
        resolve({redirect: '/'});
    })
}
